import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { TERMS_OF_USE_LINK, PRIVACY_POLICY_LINK } from '../../shared/links';
import applePayImageSrc from '../../assets/images/subscription/apple-pay-chip.png';
import googlePayImageSrc from '../../assets/images/subscription/google-pay-chip.png';
import visaImageSrc from '../../assets/images/subscription/visa-chip.png';
import mastercardImageSrc from '../../assets/images/subscription/mastercard-chip.png';
import maestroImageSrc from '../../assets/images/subscription/maestro-chip.png';
import discoverImageSrc from '../../assets/images/subscription/discover-chip.png';
import amexImageSrc from '../../assets/images/subscription/americanexpress-chip.png';
import unionpayImageSrc from '../../assets/images/subscription/unionpay-chip.png';
import styles from './AgreementTextV2.css';

const cx = classnames.bind(styles);

function AgreementTextV2({ className, legalLinks = { privacyPolicy: PRIVACY_POLICY_LINK, termsOfUse: TERMS_OF_USE_LINK } }) {
    return (
        <div className={cx('agreement', className)}>
            <p className={styles.agreementText}>
                <CustomLink
                    to={legalLinks.termsOfUse}
                    target='_blank'
                >
                    Terms&nbsp;of&nbsp;Service
                </CustomLink>
                {' and '}
                <CustomLink
                    to={legalLinks.privacyPolicy}
                    target='_blank'
                >
                    Privacy&nbsp;Policy
                </CustomLink>
            </p>
            <p className={styles.copyright}>{`©${new Date().getFullYear()} Boundly. All rights reserved.`}</p>
            <ul className={styles.payments}>
                <li><img alt='Apple Pay' src={applePayImageSrc} /></li>
                <li><img alt='Google Pay' src={googlePayImageSrc} /></li>
                <li><img alt='Visa' src={visaImageSrc} /></li>
                <li><img alt='Mastercard' src={mastercardImageSrc} /></li>
                <li><img alt='Maestro' src={maestroImageSrc} /></li>
                <li><img alt='Discover' src={discoverImageSrc} /></li>
                <li><img alt='American Express' src={amexImageSrc} /></li>
                <li><img alt='UnionPay' src={unionpayImageSrc} /></li>
            </ul>
        </div>
    );
}

AgreementTextV2.propTypes = {
    className: PropTypes.string,
    legalLinks: PropTypes.object
};

AgreementTextV2.defaultProps = {
    className: ''
};

export {
    AgreementTextV2
};
